module.exports = ".stackH {\n  max-height: 300px;\n  min-height: 100px; }\n"